import { useMemo } from 'react';

import { WidgetViewMode } from 'utilitys/reporting/widgetViewModeUtils';

import { useUpdateIfReady } from 'components/Dashboards/Reporting/widgetInReport/hooks/RefreshWidgetPayload/useUpdateIfReady';
import { UseProjectScorecardsProvider } from 'components/widgets/ProjectScorecards/ProjectScorecards.provider';
import { serializeScoreCardsData } from 'components/widgets/ProjectScorecards/ProjectScorecards.utils';

interface Props {
    api: UseProjectScorecardsProvider['api'];
    setIsPayloadReady?: (newValue: boolean) => void;
    widgetViewMode?: WidgetViewMode;
}

export const useProjectScorecardsLogic = ({ api, setIsPayloadReady, widgetViewMode }: Props) => {
    const isPayloadReady = () => {
        const currentPayload = api.getProjectScoreCardsSummary.payload;
        if (!currentPayload) return;
        if (currentPayload.filter.filters === undefined) {
            return;
        }
        setIsPayloadReady && setIsPayloadReady(true);
    };

    useUpdateIfReady({ isPayloadReadyCallback: isPayloadReady, widgetViewMode: widgetViewMode });

    const scoreCardsTableData = useMemo(() => {
        if (api.getProjectScoreCardsSummary.instance.data) {
            return serializeScoreCardsData(api.getProjectScoreCardsSummary?.instance?.data?.componentsList);
        }
        return [];
    }, [api.getProjectScoreCardsSummary.instance.data]);

    return {
        logic: {
            scoreCardsTableData,
        },
    };
};
